module.exports = __webpack_public_path__ + "img/server-sync-1.f8e6ae67.svg";